/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M19.14 18H4.86a.86.86 0 0 1-.86-.87V6.86c0-.48.39-.86.86-.86h12.47c.48 0 .73.57.4.92L12.8 12.1a1.1 1.1 0 0 1-1.62 0l-3.8-4-1.45 1.36 3.81 4.02a3.12 3.12 0 0 0 4.52 0l4.8-5.05a.55.55 0 0 1 .94.37v8.33c0 .48-.38.87-.86.87Zm0-14H4.86A2.86 2.86 0 0 0 2 6.86v10.27A2.86 2.86 0 0 0 4.86 20h14.28A2.86 2.86 0 0 0 22 17.13V6.86A2.86 2.86 0 0 0 19.14 4Z',
  DEV ? 'MailIcon' : '',
  '',
  false,
);
